<template>
  <div class="reunion">
    <div class="reunion-webview">
      <div class="content">
        <div class="header">
          <img src="../../assets/reunion/header.png" alt="">
        </div>
        <div class="main">
          <div class="cnt cnt-desc">
            <img class="cnt-img" src="../../assets/reunion/desc.png" alt="">
          </div>
          <template v-for="(product,index) in subKdts">
            <div :key="index" class="cnt" @click="handleDetailClick(product)">
              <img class="cnt-img" :src="require('../../assets/reunion/img'+ (index + 1)+'.png')" alt="">
              <div class="cnt-price">
                <span class="price-num">{{product.minPrice}}</span>
                <span class="price-unit">元</span>
              </div>
              <!-- <div class="cnt-lineThroughPrice">
                <span class="lineThroughPrice-text">原价</span>
                <span class="lineThroughPrice-num">{{product.lineThroughPrice}}元</span>
              </div> -->
              <div class="cnt_action" :class="generateClassName(index)">
                <div class="cnt_action__wapper">
                  <img v-if="!product.isDisplay" @click.stop="()=>{}" src="../../assets/reunion/buy_disabled.png" alt="">
                  <img v-else-if="product.quantity > 0" @click.stop="handleCartAddClick(product)" src="../../assets/reunion/buy_default.png" alt="">
                  <img v-else-if="product.quantity <= 0" @click.stop="()=>{}" src="../../assets/reunion/buy_none.png" alt="">
                  <openButton v-if="!isWebView" type="reunion" buttonStyle="marigin:0" buttonTxt="打开舌尖英雄App"></openButton>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="footer">
          <div class="footer-bg">
            <img class="img" src="../../assets/reunion/bg1.png" alt="">
            <!-- <img class="light" src="../../assets/reunion/bg2.png" alt=""> -->
          </div>
          <div class="footer-bg">
            <img class="img" src="../../assets/reunion/bg3.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="reunion-action" v-if="!isWebView">
      <openButton buttonStyle="margin:0" buttonTxt="打开舌尖英雄App" type="reunion"></openButton>
    </div>
  </div>
</template>
<script>

import { listItemDetail} from '../../api'
import openButton from '@/components/openButton/index'
import wx from 'weixin-js-sdk'
import qs from 'qs'
export default {
  name: 'Reunion',
  components: {
    openButton
  },
  data(){
    return{
      isWebView : false,
      subKdts:[],
      subKdtId: null,
    }
  },
  mounted(){
    window.getShareConfig = this.getShareConfig
    window.getWebViewEnv = this.getWebViewEnv
    window.reloadReunion = this.reloadReunion
    this.handleShareAction()
    const subKdtId = this.$route.query.subKdtId
    if(!subKdtId){
      return this.$toast({ message: '缺少参数'});
    }
    this.subKdtId = subKdtId
    this.listItemDetailRequest(subKdtId)
    this.h5ReunionDinnerView()
  },
  methods:{
    handleShareAction(){
      wx.ready(() => { 
        console.log('ready')
        wx.updateAppMessageShareData({ 
            title: '您有一份年夜饭礼包，请查收！',
            desc: '舌尖英雄「如虎添翼」·家宴礼包火热开售，轻松享年味!',
            link: `${window.location.origin}/#/reunion?subKdtId=${this.subKdtId}`,
            imgUrl: 'https://dj-marketingtest1.abite.com/share.png',
            success: function () {
              console.log('设置朋友成功')
            }
        })

        wx.updateTimelineShareData({ 
          title: '您有一份年夜饭礼包，请查收！',
          link: `${window.location.origin}/#/reunion?subKdtId=${this.subKdtId}`,
          imgUrl: 'https://dj-marketingtest1.abite.com/share.png',
          success: function () {
            console.log('设置朋友圈成功')
          }
        })
      }); 
    },

    h5ReunionDinnerView(){
      const utm_source = qs.parse(window.location.search, { ignoreQueryPrefix: true }).utm_source
      const code = this.$route.query.c || utm_source || ''
      console.log(code,'code')
      this.$sensors.track('h5_reunionDinner_view', { code });
    },

    h5ReunionDinnerProductDetailClick(product){
      const utm_source = qs.parse(window.location.search, { ignoreQueryPrefix: true }).utm_source
      const code = this.$route.query.c || utm_source || ''
      console.log(code,'code')
      this.$sensors.track('h5_reunionDinner_productDetail_click', { code,product_name : product.title,product_spu_id: product.itemId });
    },

    h5ReunionDinnerProductAddToCartClick(product){
      const utm_source = qs.parse(window.location.search, { ignoreQueryPrefix: true }).utm_source
      const code = this.$route.query.c || utm_source || ''
      console.log(code,'code')
      this.$sensors.track('h5_reunionDinner_productAddToCart_click', { code,product_name : product.title,product_spu_id: product.itemId });
    },

    listItemDetailRequest(subKdtId){
      const params = {
        itemDetailParamList : [
        {
          subKdtId,
          itemNo: process.env.VUE_APP_SPU1,
        },
        {
          subKdtId,
          itemNo: process.env.VUE_APP_SPU2,
        },
        {
          subKdtId,
          itemNo: process.env.VUE_APP_SPU3,
        }]
      };
      this.$toast.loading({message: '加载中...',forbidClick: true})
      listItemDetail(params).then(res =>{
        this.$toast.clear();
        console.log(res)
        if (res.code === 200) {
          if(res.busCode === '1'){
            this.subKdts = res.data || []
            console.log(res.data)
          }else{
            this.$toast({ message: res.busMessage});
          }
        } else {
          this.$toast({ message: res.message});
        }

      })
    },
    getShareConfig(){
      console.log('getShareConfig被调用')
      const shareObj = {
        shareWebTitle: '您有一份年夜饭礼包，请查收！',
        shareContent: '舌尖英雄「如虎添翼」·家宴礼包火热开售，轻松享年味!',
        litimgUrl: 'https://dj-marketingtest1.abite.com/share.png',
        shareUrl: `${window.location.origin}/#/reunion?subKdtId=${this.subKdtId}`,
      }
      console.log(JSON.stringify(shareObj))
      return JSON.stringify(shareObj)
    },
    getWebViewEnv(env){
      console.log('getWebViewEnv被调用')
      console.log(env)
      console.log(typeof env)
      this.isWebView = env
    },
    reloadReunion(subKdtId){
      console.log('reloadReunion被调用')
      this.listItemDetailRequest(subKdtId)
      this.subKdtId = subKdtId
    },
    handleDetailClick(product){
      try {
        console.log(JSON.stringify(product))
        // this.h5ReunionDinnerProductDetailClick(product)
        GoProductDetail && GoProductDetail.postMessage(JSON.stringify(product))
      } catch (error) {
        console.log(JSON.stringify(product))
        console.log(error)
      }
    },
    handleCartAddClick(product){
      try {
        console.log(JSON.stringify(product))
        // this.h5ReunionDinnerProductAddToCartClick(product)
        AddToCart && AddToCart.postMessage(JSON.stringify(product))
      } catch (error) {
        console.log(JSON.stringify(product))
        console.log(error)
      }
    },
    generateClassName(index){
      return "cnt_action_" + (index+1);
    }
  }
}
</script>

<style lang="scss" scoped>
.reunion{
  position: relative;
  height: 100%;
  overflow-x: hidden;
  font-family: SourceHanSerifCN-Bold, SourceHanSerifCN !important;
  .reunion-webview{
    height: 100%;
    overflow-y: auto;
    font-size: 0;
  }
  .reunion-h5{
    height: calc(100% - 96px - 40px);
  }
  .content{
     position: relative;
     background-image: linear-gradient(to right, #da2b2b , #e03d32 ,#da2b2b);
    .header{
      height: 910px;
      img{
        width: 100%;
      }
    }
    .main{
      position: relative;
      padding: 0 0 250px;
      .cnt{
        position: relative;
        margin-bottom: 36px;
        .cnt-img{
          width: 100%;
        }
        .cnt-price{
          color: #EFD8A8;
          position: absolute;
          left: 24px;
          top: 604px;
          width: 240px;
          text-align: center;
          .price-num{
            display: inline-block;
            height: 100px;
            font-size: 96px;
            font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
            font-weight: bold;
            color: #F7E2B4;
            line-height: 100px;
            background: linear-gradient(229deg, #FFECC6 0%, #D5B268 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .price-unit{
            font-size: 32px;
            font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
            font-weight: bold;
            color: #FBE9BF;
            line-height: 44px;
            position: relative;
            top: -2px;
            background: linear-gradient(229deg, #FFECC6 0%, #F6E0B1 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            display: inline-block;
          }
        }
        .cnt-lineThroughPrice{
          color: #EFD8A8;
          position: absolute;
          left: 0;
          top: 676px;
          width: 240px;
          text-align: center;
          font-size: 19px;
          font-weight: bold;
          .lineThroughPrice-text{
            margin-right: 4px;
          }
          .lineThroughPrice-num{
            text-decoration: line-through;
          }
        }
        .cnt_action{
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 108px;
          overflow: hidden;
          z-index: 1;
          .cnt_action__wapper{
            position: relative;
            overflow: hidden;
            .open-button{
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              bottom: 0;
              opacity: 0;
            }
            img{
              height: 96px;
            }
          }
        }
        .cnt_action_1{
          bottom: 190px;
        }
        .cnt_action_2{
           bottom: 208px;
        }
        .cnt_action_3{
          bottom: 210px;
        }
      }
    }
    .footer{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      .footer-bg{
        position: relative;
        .light{
          width: 100%;
          position: absolute;
          left:0;
          right: 0;
          bottom: 0;
        }
        .img{
          width: 100%;
        }
      }
    }
  }
  .reunion-action{
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    padding: 20px 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
  }
}
</style>
